export enum UserType {
  None = 0,
  FirstCapturedUser = 1,
  LastCapturedUser = 2,
  ReassignedBy = 3,
  ValidatedBy = 4,
  AuditedBy = 5,
  ReviewedBy = 6,
}